import { useCallback, useState } from "react";
import { Outlet } from "react-router-dom";
import { XIcon } from "lucide-react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../../components/ui/tabs";
import { Input } from "../../../components/ui/input";
import SearchIcon from "../../../assets/svgs/common/search.svg";
import { debounce } from "../../../utils/utils";

import { KycApprovalTable } from "../../../components/kyc-approval-table.components";
import { KycType } from "../../../types/models/kyc.types";

export default function KycApprovalsAdminPartial() {
  const [currentTab, setCurrentTab] = useState(KycType.GST);
  const [search, setSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const debouncedSetSearchQuery = useCallback(
    debounce((value: string) => setSearchQuery(value.trim()), 500),
    [],
  );

  function handleSearch(e: React.ChangeEvent<HTMLInputElement>) {
    setSearch(e.target.value);
    debouncedSetSearchQuery(e.target.value);
  }

  function handleClearSearch() {
    setSearch("");
    setSearchQuery("");
  }

  function handleTabChange(val: string) {
    setCurrentTab(val as KycType);
    setSearch("");
    setSearchQuery("");
  }

  return (
    <div className="flex flex-col justify-start items-center gap-5 p-8 w-full min-h-screen text-primary container">
      <div className="flex justify-between items-center px-5 w-full text-white">
        <p className="font-semibold text-2xl">KYC Approvals</p>
      </div>

      <div className="w-full max-w-full px-5">
        <Tabs
          value={currentTab}
          onValueChange={handleTabChange}
          className="w-full"
        >
          <div className="flex justify-between items-center mb-4">
            <TabsList>
              <TabsTrigger value={KycType.GST}>GST Approval</TabsTrigger>
              <TabsTrigger value={KycType.PAYOUT}>
                Payout Method Approval
              </TabsTrigger>
            </TabsList>

            <div className="relative flex items-center bg-bginput py-2 pl-5 border border-border rounded-10">
              <SearchIcon />
              <Input
                value={search}
                onChange={handleSearch}
                className="bg-transparent border-none w-96 font-semibold text-base placeholder:text-secondary"
                placeholder="Search by name, legal name, and trade name"
              />
              {search.trim().length > 0 && (
                <XIcon
                  onClick={handleClearSearch}
                  className="right-5 absolute cursor-pointer"
                />
              )}
            </div>
          </div>

          <TabsContent value={KycType.GST}>
            <KycApprovalTable type={KycType.GST} searchQuery={searchQuery} />
          </TabsContent>

          <TabsContent value={KycType.PAYOUT}>
            <KycApprovalTable type={KycType.PAYOUT} searchQuery={searchQuery} />
          </TabsContent>
        </Tabs>
      </div>
      <Outlet />
    </div>
  );
}
